<div class="flex  w-full justify-between ">
    <h2 class="text-xl font-bold">
        {{ 'GL.CLIENT_GL.TITLE' | translate }}
    </h2>
    <button class="btn btn-primary mb-3 font-bold" (click)="openAddPopup()">
        {{ 'GL.CLIENT_GL.ADD' | translate }}
    </button>
</div>
<app-table [columns]="columns" [data]="data" [actions]="actions" [pageSize]="10" [enablePagination]="true">
</app-table>

<app-popup
  [(show)]="showPopup"
  [title]="popupTitle"
  [type]="popupType"
  [fields]="popupFields"
  [message]="popupMessage"
  [confirmText]="'COMMON.DELETE'"
  [cancelText]="'COMMON.CANCEL'"
  [onSave]="handleSave.bind(this)"
  (confirmed)="handleDelete()">
</app-popup>